import React, { useEffect, useRef, useState } from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import "./ServiceDetails.css"
import { useNavigate, useLocation } from 'react-router-dom'

const ServiceDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const serviceRefs = useRef({});

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Check if we need to scroll to a specific service
    if (location.state?.scrollToService) {
      const serviceId = location.state.scrollToService;
      
      // Wait a bit for the page to render and AOS animations to initialize
      setTimeout(() => {
        const element = serviceRefs.current[serviceId];
        if (element) {
          const offset = 100; // Offset from top (adjust as needed)
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 500);
    }
  }, [location]);

  const services = [
    {
      id: 1,
      title: "Integrated Media & Brand Management Services",
      shortTitle: "Media & Brand Management",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
      description: "An array of Digital Media & Brand Management solutions which includes:",
      features: [
        "Search Engine Optimization (SEO)",
        "Pay-Per-Click Advertising (PPC)",
        "Social Media Marketing (SMM)",
        "Content Management",
        "Email Marketing",
        "Influencer Marketing",
        "Video Marketing",
        "Google Analytics",
        "Website Building",
        "Presentation Design (PPTs)",
        "Brochure Design",
        "Graphics Design",
        "Branding and Brand Strategy",
        "Marketing Analytics",
        "Online Reputation Management (ORM)"
      ]
    },
    {
      id: 2,
      title: "Land Acquisition, Alienation, Rehabilitation & Resettlement Services",
      shortTitle: "Land Acquisition & Resettlement",
      image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80",
      description: "Comprehensive land management services for large-scale projects:",
      features: [
        "Field Survey with Drone/DGPS instrument of contour map preparation",
        "Preparation of KML & KMZ file and Geo-reference map preparation",
        "Topo map preparation",
        "Site Selection with 3-4 alternatives",
        "Due Diligence, Title Search, Field Survey and Consent of Land Owners",
        "Various regulatory clearances including facilitation for land & water assessment from IPICOL Odisha",
        "Facilitating for land acquisition, land alienation, rehabilitation & resettlement",
        "Negotiation for direct purchase of private land for projects",
        "Facilitating for public hearing, Gram Sabha, RPDAC meetings",
        "Regularisation of land and field disputes",
        "Stakeholder engagement at various levels (State, Districts, Local)",
        "Dedicated MIS with Agile project management",
        "Target to deliver the clearance well ahead of the timeline"
      ]
    },
    {
      id: 3,
      title: "Due Diligence, Title Search, Field Survey & Legal Matters",
      shortTitle: "Due Diligence & Legal Services",
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
      description: "Comprehensive legal and survey services for land-related matters:",
      features: [
        "Complete Due Diligence of land parcels and properties",
        "Title Search and verification of land ownership documents",
        "Field Survey using advanced DGPS and drone technology",
        "Legal assessment of land titles and encumbrances",
        "Consent management and documentation from land owners",
        "Land measurement and boundary verification",
        "Historical land record analysis",
        "Legal opinion on land acquisition matters",
        "Documentation support for land transactions",
        "Coordination with revenue departments and authorities",
        "Risk assessment and mitigation strategies",
        "Comprehensive legal reports and recommendations"
      ]
    },
    {
      id: 4,
      title: "Land Regularisation & Dispute Resolution Services",
      shortTitle: "Land Regularisation",
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80",
      description: "Expert services for land regularisation and dispute resolution:",
      features: [
        "Land title regularisation and documentation",
        "Resolution of land ownership disputes",
        "Boundary dispute mediation and settlement",
        "Coordination with revenue authorities for mutation",
        "Legal support for land encroachment issues",
        "Facilitation of land conversion processes",
        "Documentation for land use change approvals",
        "Liaison with local administration and courts",
        "Expert consultation on land law matters",
        "Settlement of family partition disputes",
        "Support in adverse possession cases",
        "Comprehensive dispute resolution strategies"
      ]
    },
    {
      id: 5,
      title: "Public Hearing for SIA Studies, Gram Sabhas & Other Forums",
      shortTitle: "Public Hearing Services",
      image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800&q=80",
      description: "Expert facilitation of public consultations and stakeholder engagement:",
      features: [
        "Organization and facilitation of Public Hearings",
        "Social Impact Assessment (SIA) study coordination",
        "Gram Sabha meeting organization and documentation",
        "RPDAC (Regional Project Development Advisory Committee) meetings",
        "Stakeholder consultation and engagement",
        "Community sensitization programs",
        "Documentation and reporting of public consultations",
        "Conflict resolution and grievance management",
        "Multi-stakeholder dialogue facilitation",
        "Translation and interpretation services",
        "Audio-visual documentation of proceedings",
        "Compliance with regulatory requirements for public consultation"
      ]
    },
    {
      id: 6,
      title: "Integrated Railway Management Services",
      shortTitle: "Railway Management",
      image: "https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=800&q=80",
      description: "Comprehensive railway logistics and operations management:",
      features: [
        "Indent Planning: Planning and scheduling the movement of goods or materials by rail, determining required wagons, route, and timing",
        "Rake Allocation & Evacuation: Allocating and evacuating railway wagons to ensure efficient and timely transportation",
        "Railway Siding Design & Construction: Designing and constructing railway sidings for loading and unloading cargo",
        "Private Rake Operations: Complete operations management with dedicated control room for private rakes",
        "Integrated Railway Logistics Management with Zero Faults Approach",
        "Real-time tracking and monitoring of railway consignments",
        "Coordination with railway authorities and operators",
        "Optimization of wagon utilization and turnaround time",
        "Documentation and compliance management",
        "Emergency response and contingency planning",
        "Performance analytics and reporting",
        "Cost optimization strategies for railway logistics"
      ]
    }
  ];

  return (
    <>
      <Header />
      {/* Hero Section */}
      <section className='services-details-hero'>
        <article className='services-details-hero-gap'>
          <div className='services-details-texts'>
            <h1 className='services-details-head-text'>
              Our Integrated <br />Services
            </h1>
            <p className='services-details-sub-text'>
              Integrated solutions designed to connect communities, empower enterprises,
              <br />and enable large-scale development.
            </p>
          </div>
        </article>
      </section>

      {/* ============= service details ---------- */}
      <section className="services-detailed-section">
        <div className="services-container">
          {services.map((service, index) => (
            <div
              key={service.id}
              ref={(el) => (serviceRefs.current[service.id] = el)}
              data-aos="fade-up"
              className={`service-item ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
              id={`service-${service.id}`}
            >
              <div className="service-image-wrapper">
                <img src={service.image} alt={service.title} className="service-image" />
                <div className="service-number-overlay">
                  {String(index + 1).padStart(2, '0')}
                </div>
              </div>

              <div className="service-text-wrapper">
                <h2 className="service-title">{service.title}</h2>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="service-feature-item">
                      <span className="feature-icon">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button className="contact-us-btn" onClick={() => { navigate("/contact") }}>
                  Contact Us
                  <span className="arrow-icon">→</span>
                </button>
              </div>

            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  )
}

export default ServiceDetails